import { ISupplierPagedRequest } from '../../../../model/sge/supplier/request/supplier-paged-request';

export type SupplierSearchState = {
    parameters: ISupplierPagedRequest;
    searchTrigger: number;
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    triggerSearch = 'triggerSearch',
}

export const SupplierSearchReducer = (state: SupplierSearchState, action: any): SupplierSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
